// Mock data for The Sterling Touch - Premium Cleaning Services (Brisbane)
//
// ============================================================
// IMAGES — Replace any of these URLs with your own Brisbane home photos.
// Just paste a new image URL between the quotes. That's it.
// Recommended size: 1200x900px or larger. JPEG/PNG/WebP all work.
// ============================================================

export const IMAGES = {
  hero:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/ehz7t67j_Hero%20Image%20%282%29.png",
  about:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/4tv9ymah_Behind%20the%20Sterling%20Touch.png",
  privacy:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/qtbxqifz_Mopping%20Floors.png",
  // Service images
  propertyPresentation:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/t8yoq4dy_Presentation%20Clean.png",
  residential:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/gdjg2td6_Express%20Reset.png",
  deepCleaning:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/9hxwqpk8_Deep%20Clean.png",
  bondCleaning:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/y2xdhau3_Bond%20Clean.png",
  airbnbTurnover:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/2ahsmcbs_AirBnB%20Turnover.png",
  sanctuaryReset:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/m3oraf0y_Sanctuary%20Reset%20-%20Spring%20Clean.png",
  products:
    "https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/asr8vn0e_Livingroom.png",
};

export const hero = {
  // ============================================================
  // HERO HEADLINE — edit these to change what's shown on the landing page
  // ============================================================
  eyebrow: "Brisbane’s Premium Clean",
  headlineStart: "Stop Cleaning. Start Coming Home to ",         // shown in regular weight
  headlineAccent: "Calm.",               // shown in italic peach color
  subtext:
    "Designed for homes that deserve more than a standard clean. Tailored, discreet and meticulous — a refined cleaning service for homes that deserve more.",
  primaryCta: "Book your clean",
  secondaryCta: "Explore services",
  trustPoints: ["Fully insured", "Police checked", "Satisfaction guaranteed"],
  // Quote form labels
  formEyebrow: "Personalised Quote",
  formTitle: "Tell us about your space",
  formSubtitle: "We respond within 24 hours with a tailored quote.",
};

export const brand = {
  name: "The Sterling Touch",
  tagline: "Where Cleaning Meets Presentation",
  subtagline: "Designed for homes that deserve more than a standard clean.",
  phone: "+61 413 996 908",
  email: "hello@thesterlingtouch.com.au",
  hours: {
    weekday: "Mon–Fri: 8:30am – 5:00pm",
    saturday: "Saturday: 9:00am – 3:00pm",
    sunday: "Sunday: Closed",
  },
  location: "Brisbane, Australia",
};

export const stats = [
  { value: "300+", label: "Hours Cleaning" },
  { value: "100%", label: "Tailored Service" },
  { value: "20+", label: "Spaces Transformed" },
  { value: "100%", label: "Satisfaction Guarantee" },
];

export const services = [
  {
    id: "express-reset",
    title: "Express Reset",
    subtitle: "Maintenance Clean",
    short: "Express Reset",
    tagline: "The home feels calm again.",
    description: "A quick, thorough clean for busy lives.",
    startingPrice: "$150",
    priceNote: "2.5 – 4 hours",
    duration: "2.5 – 4 hours",
    badge: "Most booked weekly",
    image: IMAGES.residential,
    perfectFor: [
      "Busy professionals",
      "Weekly or fortnightly upkeep",
      "Families needing breathing room again",
    ],
    included: [
      { title: "Kitchen Refresh", desc: "Surfaces cleaned, sinks & splashbacks wiped, appliances touched up." },
      { title: "Bathroom Refresh", desc: "Basins, toilets, showers & mirrors cleaned for a fresh finish." },
      { title: "Vacuum & Mop", desc: "Floors vacuumed and mopped for a clean, fresh feel." },
      { title: "Surface Detailing", desc: "Dusting and wiping of all accessible surfaces." },
      { title: "Bed Making & Finishing Touches", desc: "Beds made, cushions fluffed, and the finishing touches that make all the difference." },
      { title: "Light Tidy & Reset", desc: "A tidy and reset of key areas so your home feels calm again." },
    ],
  },
  {
    id: "sanctuary-reset",
    title: "Sanctuary Reset",
    subtitle: "Premium Spring Clean",
    short: "Sanctuary Reset",
    tagline: "The home feels calm again.",
    description: "A deep, whole-home reset designed to restore calm and comfort.",
    startingPrice: "$240",
    priceNote: "4 – 5 hours",
    duration: "4 – 5 hours",
    badge: "Our most popular reset package",
    image: IMAGES.sanctuaryReset,
    perfectFor: [
      "Homes needing a seasonal reset",
      "Busy families & professionals",
      "Restores calm, comfort and order",
      "Leaves your home feeling refreshed, clean and re-energised",
    ],
    included: [
      { title: "Detailed Bathrooms", desc: "Thorough cleaning of basins, toilets, showers, mirrors and all surfaces." },
      { title: "Kitchen Deep Refresh", desc: "Detailed cleaning of all surfaces, sinks, splashbacks and appliances (exterior)." },
      { title: "Skirting Boards & Detail Work", desc: "Careful dusting and cleaning of skirting boards, corners and edges." },
      { title: "Dusting & High-Touch Surfaces", desc: "Complete dusting and sanitising of all high-touch areas." },
      { title: "Glass & Mirror Polishing", desc: "Streak-free shine on mirrors, glass surfaces and fixtures." },
      { title: "Whole-Home Vacuum & Mop", desc: "Floors vacuumed and mopped throughout for a fresh finish." },
    ],
  },
  {
    id: "presentation-clean",
    title: "Presentation Clean",
    subtitle: "Pre-Sale, Inspection or Move",
    short: "Presentation Clean",
    tagline: "Because first impressions matter.",
    description: "A polished, show-ready clean that makes your home look its absolute best.",
    startingPrice: "$280",
    priceNote: "4 – 5 hours · tailored to your home",
    duration: "4 – 5 hours",
    badge: "Styled for impact",
    image: IMAGES.propertyPresentation,
    priceFootnote:
      "Can be tailored to the size of your home.",
    perfectFor: [
      "Inspection-ready for real estate inspections",
      "Sale-ready — present your home at its absolute best",
      "Move in / out ready — ideal for moving or settling in",
      "Real estate & Airbnb presentation cleans",
      "Ideal for preparing your home for guests",
      "Perfect before hosting or celebrations",
      "Designed to make your home shine",
      "Beautiful results, every time",
    ],
    included: [
      { title: "Whole-Home Tidy & Reset", desc: "We put everything back in place and ensure your home looks neat, calm and inviting." },
      { title: "Kitchen Perfected", desc: "Bench tops polished, sink shining, surfaces wiped and everything sparkling." },
      { title: "Bedrooms Beautifully Prepared", desc: "Beds made, surfaces dusted, mirrors cleaned and spaces styled to impress." },
      { title: "Detail Clean Throughout", desc: "High-touch areas, skirting boards, corners and finishes cleaned with care." },
      { title: "Glass & Mirror Shine", desc: "Streak-free shine on mirrors, glass doors, windows and reflective surfaces." },
      { title: "Floors Fresh & Tidy", desc: "Floors vacuumed and mopped for a clean, polished finish." },
    ],
  },
  {
    id: "deep-clean",
    title: "Deep Clean",
    subtitle: "A True Reset",
    short: "Deep Clean",
    tagline: "The home feels calm again.",
    description: "A thorough, top-to-bottom clean for homes that need a true reset.",
    startingPrice: "$300",
    priceNote: "4 – 8 hours",
    duration: "4 – 8 hours",
    badge: "The ultimate reset for a healthier, cleaner home",
    image: IMAGES.deepCleaning,
    priceFootnote:
      "Pricing may vary depending on size and condition of the home.",
    perfectFor: [
      "Homes that haven’t been professionally cleaned in a while",
      "Move-in, catch-up or post-renovation cleans",
      "Removes built-up dirt, grime and bacteria",
      "Leaves your home feeling completely refreshed",
      "Eco-friendly products, safe for your family and pets",
    ],
    included: [
      { title: "Intensive Bathroom Clean", desc: "Deep cleaning of basins, toilets, showers, tiles, grout and all surfaces." },
      { title: "Kitchen Deep Clean", desc: "Degreasing and deep cleaning of all surfaces, appliances (inside & out), sinks and splashbacks." },
      { title: "Skirting Boards, Corners & Tracks", desc: "Detailed cleaning of skirting boards, corners, edges and window tracks." },
      { title: "Deep Dusting & High-Touch Surfaces", desc: "Thorough dusting and sanitising of all areas, including hard-to-reach spots." },
      { title: "Floors Vacuumed & Mopped", desc: "All floors vacuumed and mopped for a deep, fresh finish." },
      { title: "Extra Detail Finish", desc: "Cobweb removal, spot cleaning, light switches, door handles and more." },
    ],
  },
  {
    id: "bond-clean",
    title: "Bond Clean",
    subtitle: "End-of-Lease Cleaning",
    short: "Bond Clean",
    tagline: "A spotless finish for a smoother move-out.",
    description: "Inspection-ready cleaning designed to prepare your home for final inspection and handover.",
    startingPrice: "$699",
    priceNote: "3 bed / 2 bath · oven deep clean included",
    duration: "Full day",
    badge: "Real-estate inspection ready",
    image: IMAGES.bondCleaning,
    perfectFor: [
      "Real estate inspection-ready finish",
      "Detailed & thorough cleaning",
      "Professional results you can trust",
      "Oven deep clean & detailed bathrooms included",
    ],
    included: [
      { title: "Bathrooms Detailed", desc: "Showers, baths, toilets, tiles, grout and all surfaces thoroughly cleaned." },
      { title: "Oven Deep Clean", desc: "Oven, racks and trays deep cleaned inside and out." },
      { title: "Cupboards & Drawers", desc: "All cupboards, drawers and storage spaces wiped clean." },
      { title: "Mirrors & Glass", desc: "Mirrors, windows, tracks and glass surfaces streak-free." },
      { title: "Floors", desc: "All floors vacuumed and mopped." },
      { title: "Kitchen Degreasing", desc: "Bench tops, splashbacks, rangehood (exterior), stove top and all surfaces degreased and cleaned." },
      { title: "Cobweb Removal", desc: "Cobwebs removed from ceilings, corners and hard-to-reach areas." },
      { title: "Skirting Boards", desc: "Skirting boards, corners and edges cleaned throughout." },
      { title: "Spot Cleaning", desc: "Marks and scuffs on walls and surfaces removed where possible." },
      { title: "Appliance Exterior", desc: "All appliance exteriors cleaned and polished." },
    ],
    addons: [
      { name: "Extra Oven", price: "from $50" },
      { name: "Internal Windows", price: "from $100" },
      { name: "Wall Washing", price: "quoted separately" },
      { name: "Balcony Clean", price: "from $60" },
      { name: "Shower Restoration", price: "from $80" },
      { name: "Cleaning Blinds", price: "from $50" },
    ],
    priceFootnote:
      "Pricing varies depending on home condition, build-up and additional requirements. Excessive build-up, additional appliances or extra areas may incur additional charges.",
  },
  {
    id: "airbnb-turnover",
    title: "Airbnb Turnover Cleaning",
    subtitle: "Professional Care. Every Turnover.",
    short: "Airbnb Turnover",
    tagline: "We clean, so you can host.",
    description:
      "Reliable turnover cleans that keep your space guest-ready, protect your property and help you earn 5★ reviews. Designed for short-stay hosts who want a meticulous, repeatable standard between every guest.",
    startingPrice: "$129",
    priceNote: "1 bed / 1 bath · turnover from",
    duration: "Same-day turnaround",
    badge: "Host-trusted · 5★ ready",
    image: IMAGES.airbnbTurnover,
    perfectFor: [
      "Airbnb, Stayz and short-stay hosts",
      "Professional property managers",
      "Holiday rental owners between guests",
      "Hosts chasing consistent 5★ reviews",
    ],
    included: [
      {
        title: "Bedroom Refresh",
        desc: "Beds made, linen changed, surfaces dusted and room fully reset for the next guest.",
      },
      {
        title: "Bathroom Sanitised",
        desc: "Showers, toilets, sinks and mirrors cleaned, sanitised and restocked.",
      },
      {
        title: "Kitchen Sparkling",
        desc: "Benchtops cleaned, appliances wiped, dishes checked and bins emptied.",
      },
      {
        title: "Living Areas Ready",
        desc: "Surfaces wiped, floors vacuumed and mopped, furniture fluffed and tidy.",
      },
      {
        title: "Linen & Restock",
        desc: "Fresh linen supplied* and guest essentials restocked so the space is ready to host.",
      },
      {
        title: "Final Check & Report",
        desc: "Quality inspection completed and property left guest-ready, every time.",
      },
      {
        title: "Damage & Issue Flagging",
        desc: "We carefully inspect the property each turnover and flag any damage, maintenance issues or missing items so you can address them early and protect your investment.",
      },
    ],
    addons: [
      { name: "Linen Service", price: "from $40" },
      { name: "Restock of Essentials", price: "from $25" },
      { name: "Mid-Stay Refresh", price: "quoted" },
      { name: "Balcony / Outdoor Tidy", price: "from $40" },
    ],
    packages: [
      { name: "1 Bed / 1 Bath", desc: "Homes & apartments" },
      { name: "2 Bed / 2 Bath", desc: "Spacious homes" },
      { name: "3+ Bed / 2+ Bath", desc: "Larger or multi-level homes" },
    ],
    priceFootnote:
      "Pricing is based on property size, condition and services required. Linen service available as an add-on. Add-on options available — we tailor each turnover to suit your property.",
  },
];

export const whyChooseUs = [
  {
    icon: "Clock",
    title: "Always On Time",
    description:
      "We respect your schedule — our team arrives promptly and ready to work.",
  },
  {
    icon: "CalendarCheck",
    title: "Flexible Scheduling",
    description:
      "One-time or recurring, morning or afternoon — we adjust to what works best for you.",
  },
  {
    icon: "Sparkles",
    title: "Truly Spotless Results",
    description:
      "We don’t just tidy up — we clean thoroughly, leaving your space fresh and flawless.",
  },
  {
    icon: "ShieldCheck",
    title: "Trusted, Insured Team",
    description:
      "Police-checked, fully insured and friendly — a team you can comfortably welcome into your space.",
  },
];

export const promises = [
  "Respectful, discreet service",
  "Designed for premium homes",
  "Attention to detail beyond standard cleaning",
  "Fully insured & police checked",
];

export const testimonials = [
  {
    name: "Olivia M.",
    location: "New Farm, QLD",
    rating: 5,
    text:
      "The Sterling Touch transformed our home before listing. Every detail was considered — the agent said it photographed like a magazine.",
  },
  {
    name: "James R.",
    location: "Ascot, QLD",
    rating: 5,
    text:
      "Discreet, punctual and meticulous. They’ve become a quiet luxury in our weekly routine. I cannot recommend them enough.",
  },
  {
    name: "Priya S.",
    location: "Hamilton, QLD",
    rating: 5,
    text:
      "They take care of details I didn’t even know I cared about. Walking into a freshly cleaned home is genuinely uplifting.",
  },
  {
    name: "Daniel H.",
    location: "Bulimba, QLD",
    rating: 5,
    text:
      "Bond clean was flawless — full deposit returned without a single comment. Worth every dollar.",
  },
];

export const faqs = [
  {
    q: "What areas do you service?",
    a: "The Sterling Touch services selected suburbs across Brisbane and surrounding prestige areas. If you are unsure whether we service your suburb, simply submit a quote request and we will confirm availability.",
  },
  {
    q: "Do I need to be home during the cleaning?",
    a: "Not at all! Many clients provide us with access instructions. Your security and privacy are always respected.",
  },
  {
    q: "Do you bring your own cleaning equipment and products?",
    a: "Yes. We arrive fully equipped with professional cleaning products and tools required to deliver a high-quality result. If you prefer specific products to be used in your home, we are happy to accommodate this upon request.",
  },
  {
    q: "Can I be working from home while the cleaning is taking place?",
    a: "Yes, many of our clients work from home while we clean. Our team works quietly and respectfully to minimise disruption. If you have meetings scheduled, simply let us know and we will prioritise other areas of the home first where possible.",
  },
  {
    q: "What happens if someone in the home is unwell?",
    a: "If anyone in the household is experiencing contagious illness symptoms, we kindly ask that the appointment be rescheduled. This helps protect both our cleaners and other clients. We are always happy to arrange a new time once everyone is feeling better. If illness occurs close to your booking, please contact us as soon as possible so we can assist with rescheduling.",
  },
  {
    q: "Do you work in homes with pets?",
    a: "Yes, we are happy to clean homes with pets. For the comfort and safety of both our cleaners and your pets, we ask that animals are secured or supervised during the service where possible. If your pet is friendly and accustomed to visitors, they are of course welcome to remain in the home. Please let us know in advance if pets will be present so we can prepare accordingly.",
  },
  {
    q: "What is your cleaning approach for homes with pets?",
    a: "Our pet-friendly cleaning approach includes: removing pet hair from floors, furniture and surfaces; cleaning and sanitising pet feeding areas; freshening floors and high-traffic areas where pets spend time; careful attention around pet beds and resting spaces; and using cleaning methods that are mindful of pets in the home.",
  },
  {
    q: "What about pet mess such as urine or accidents?",
    a: "We understand that accidents can occasionally happen. However, for health and safety reasons, The Sterling Touch does not handle active biological waste such as pet urine, faeces or litter tray waste during a standard clean. We kindly ask that these areas are addressed prior to our arrival. Once the area has been cleared, we are happy to assist with sanitising the surrounding floor area, cleaning nearby surfaces, and removing odours from hard flooring where possible. For persistent odours or stains in carpets or upholstery, we can recommend trusted professional carpet cleaning partners.",
  },
  {
    q: "Are you insured?",
    a: "Yes, we’re fully insured to protect your property and our team.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking several days in advance, particularly for bond cleans, property presentation cleans, and end-of-week services. However, we will always try to accommodate urgent bookings when possible.",
  },
  {
    q: "What happens if I need to cancel or reschedule?",
    a: "We understand plans change. Please provide at least 24 hours notice if you need to reschedule your service.",
  },
  {
    q: "What payment options are available?",
    a: "Payment is typically made via online bank transfer once the service is completed. Details will be provided with your invoice.",
  },
];

export const heroImage = IMAGES.hero;
export const aboutImage = IMAGES.about;
export const privacyImage = IMAGES.privacy;
